import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';
import { Shapes } from '../../models/entities';
import Roles from '../../models/Roles';
import ClientAutoComplete from '../../containers/ClientAutoComplete';

class UserForm extends PureComponent {
  constructor(props) {
    super(props);

    const { user } = props;
    if (user) {
      this.state = { ...user };
    } else {
      this.state = {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        role: Roles.default(),
        client: undefined,
        validated: false,
      };
    }
    this.onFieldChange = this.onFieldChange.bind(this);
    this.onAutoCompleteChange = this.onAutoCompleteChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onFieldChange = (event) => {
    switch (event.target.id) {
      case 'firstName': return (this.setState({ firstName: event.target.value }));
      case 'lastName': return (this.setState({ lastName: event.target.value }));
      case 'email': return (this.setState({ email: event.target.value }));
      case 'password': return (this.setState({ password: event.target.value }));
      case 'confirmPassword': return (this.setState({ confirmPassword: event.target.value }));
      case 'role': return (this.setState({ role: event.target.value }));
      case 'client': return (this.setState({ client: event.target.value }));
      default: return this.state;
    }
  }

  onAutoCompleteChange = (selected) => {
    if (selected && selected.length > 0) {
      this.setState({ client: selected[0].id });
    }
  }

  handleSubmit = (event) => {
    const { onSubmit } = this.props;

    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === true && this.checkPasswordsMatch()) {
      const body = (({
        firstName, lastName, email, password, role, client,
      }) => ({
        firstName,
        lastName,
        email,
        password,
        role,
        clientId: client,
      }))(this.state);
      onSubmit(body);
    }
    this.setState({ validated: true });
  }

  checkPasswordsMatch() {
    const { password, confirmPassword } = this.state;
    const { onPasswordMismatch } = this.props;

    if (password === confirmPassword) {
      return true;
    }

    onPasswordMismatch();
    return false;
  }

  render = () => {
    const {
      firstName, lastName, email, role, client, validated, id,
    } = this.state;

    const { formId, disabled, clientsById } = this.props;

    return (
      <Form noValidate validated={validated} onSubmit={this.handleSubmit} id={formId}>
        <Form.Row>
          <Col>
            <Form.Group controlId="firstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.onFieldChange}
                value={firstName}
                placeholder="Enter the first name"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the first name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="lastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.onFieldChange}
                value={lastName}
                placeholder="Enter the last name"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the last name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="email">
              <Form.Label>E-mail</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.onFieldChange}
                value={email}
                placeholder="Enter the e-mail address"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the e-mail address.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="role">
              <Form.Label>Role</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                as="select"
                onChange={this.onFieldChange}
                value={role}
              >
                {Roles.values.map((value) => (
                  <option key={value} value={value}>{Roles.labelOf(value)}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="client">
              <Form.Label>Client</Form.Label>
              <ClientAutoComplete
                onChange={this.onAutoCompleteChange}
                disabled={disabled || Roles.isManager(role)}
                defaultSelected={clientsById[client]}
              />
            </Form.Group>
          </Col>
        </Form.Row>
        {disabled ? null : (
          <Form.Row>
            <Col>
              <Form.Group controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  disabled={disabled}
                  required={!id}
                  type="password"
                  onChange={this.onFieldChange}
                  placeholder="Enter the password"
                />
                <Form.Control.Feedback type="invalid">
                  Please provide the password.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="confirmPassword">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  disabled={disabled}
                  required={!id}
                  type="password"
                  onChange={this.onFieldChange}
                  placeholder="Enter the e-mail address"
                />
                <Form.Control.Feedback type="invalid">
                  Please confirm the password.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Form.Row>
        )}
      </Form>
    );
  }
}

UserForm.propTypes = {
  onSubmit: PropTypes.func,
  onPasswordMismatch: PropTypes.func,
  formId: PropTypes.string.isRequired,
  user: Shapes.USER,
  disabled: PropTypes.bool,
  clientsById: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })),
};

UserForm.defaultProps = {
  onSubmit: undefined,
  onPasswordMismatch: undefined,
  user: undefined,
  disabled: false,
  clientsById: {},
};

export default UserForm;
